import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { formatDay } from '../utils/dates';
import PagedRows from './PagedRows';

const money = (n) => new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(n || 0);
const dateStr = (d) => formatDay(d);

const VentasTab = ({ byClient, byProduct, customersActivity }) => (
  <div className="mt-3">
    <Row className="mb-3">
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <Card.Title>Ventas por Cliente</Card.Title>
          <PagedRows rows={byClient}>{(rows) => (
            <Table hover size="sm" className="mb-0">
              <thead><tr><th>Cliente</th><th># Facturas</th><th className="text-end">Total</th></tr></thead>
              <tbody>
                {rows.map((c, i) => (
                  <tr key={i}><td>{c.name}</td><td>{c.invoiceCount}</td><td className="text-end">{money(c.total)}</td></tr>
                ))}
                {byClient.length === 0 && <tr><td colSpan={3} className="text-muted text-center">Sin datos en este rango.</td></tr>}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <Card.Title>Ventas por Producto</Card.Title>
          <PagedRows rows={byProduct}>{(rows) => (
            <Table hover size="sm" className="mb-0">
              <thead><tr><th>Producto</th><th>Cantidad</th><th className="text-end">Ingresos</th></tr></thead>
              <tbody>
                {rows.map((p, i) => (
                  <tr key={i}><td>{p.name}</td><td>{p.quantity}</td><td className="text-end">{money(p.revenue)}</td></tr>
                ))}
                {byProduct.length === 0 && <tr><td colSpan={3} className="text-muted text-center">Sin datos en este rango.</td></tr>}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <Card.Title>Clientes Nuevos</Card.Title>
          <PagedRows rows={customersActivity?.newCustomers || []}>{(rows) => (
            <Table hover size="sm" className="mb-0">
              <thead><tr><th>Cliente</th><th>RNC/Cédula</th><th>Desde</th></tr></thead>
              <tbody>
                {rows.map(c => (
                  <tr key={c._id}><td>{c.name}</td><td>{c.rnc || c.cedula || '—'}</td><td>{dateStr(c.createdAt)}</td></tr>
                ))}
                {(customersActivity?.newCustomers || []).length === 0 && (
                  <tr><td colSpan={3} className="text-muted text-center">Sin clientes nuevos en este rango.</td></tr>
                )}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="shadow-sm p-3 card-equal-height">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Card.Title className="mb-0">Clientes Inactivos</Card.Title>
            <span className="text-muted small">sin compras en {customersActivity?.inactiveDays ?? 60} días</span>
          </div>
          <PagedRows rows={customersActivity?.inactiveCustomers || []}>{(rows) => (
            <Table hover size="sm" className="mb-0">
              <thead><tr><th>Cliente</th><th>RNC/Cédula</th><th>Teléfono</th></tr></thead>
              <tbody>
                {rows.map(c => (
                  <tr key={c._id}><td>{c.name}</td><td>{c.rnc || c.cedula || '—'}</td><td>{c.phone || '—'}</td></tr>
                ))}
                {(customersActivity?.inactiveCustomers || []).length === 0 && (
                  <tr><td colSpan={3} className="text-muted text-center">No hay clientes inactivos.</td></tr>
                )}
              </tbody>
            </Table>
          )}</PagedRows>
        </Card>
      </Col>
    </Row>
  </div>
);

export default VentasTab;
